import React, {Component} from 'react'

class MediaPageNav extends Component {

  render(){
    return(
      <div className="sp-pagebuilder-media-loadmore clearfix">
        <a
          className="sp-pagebuilder-btn sp-pagebuilder-btn-primary sp-pagebuilder-btn-lg sp-pagebuilder-media-loadmore"
          href="#"
          onClick={ this.props.onHandlePageNavClick }
        >
          <i className="fa fa-spinner fa-spin fa-fw"></i>
          <i className="fa fa-refresh non-spin"></i> Load More
        </a>
      </div>
    )
  }
}

export default MediaPageNav;



// WEBPACK FOOTER //
// ./src/helpers/form/types/media-helper/MediaPageNav.js